import React, { useEffect, useRef, useState } from 'react'
import { deepFind } from 'react-children-utilities'
import { usePopper } from 'react-popper'

const Trigger = () => null
const Content = () => null

const PopoverWithState = ({ children, visible, setVisible, options, placement = 'bottom-start', closable = false, hoverOpen = false }) => {

	const ref = useRef(null)
	const [mouseLeaveTimeout, setMouseLeaveTimeout] = useState(null);

	useEffect(() => {
		if (visible === false) {
			clearTimeout(mouseLeaveTimeout);
			setMouseLeaveTimeout(null);
		}

		const checkIfClickedOutside = (e) => {
			if (visible && ref.current && !ref.current.contains(e.target) && closable === true) {
				setVisible(false)
			}
		}
		document.addEventListener("click", checkIfClickedOutside)
		return () => {
			document.removeEventListener("click", checkIfClickedOutside)
		}
	}, [visible])

	const handleMouseEnter = () => {
		if (hoverOpen === true) {
			if (mouseLeaveTimeout) {
				clearTimeout(mouseLeaveTimeout);
				setMouseLeaveTimeout(null);
			}

			setVisible(true);
		}
	};

	const handleMouseLeave = () => {
		const timeoutId = setTimeout(() => {
			if (closable === true && hoverOpen === true)
				setVisible(false);
		}, 1000);

		setMouseLeaveTimeout(timeoutId);
	};

	const trigger = deepFind(children, child => child.type === Trigger)
	const content = deepFind(children, child => child.type === Content)

	const [referenceElement, setReferenceElement] = useState(null)
	const [popperElement, setPopperElement] = useState(null)
	const { styles, attributes } = usePopper(referenceElement, popperElement, { placement: placement, ...options })

	return (
		<div ref={ref}>
			<div style={{ display: 'inline-block' }} ref={setReferenceElement}>
				{trigger && (
					<div
						onMouseEnter={handleMouseEnter}
						onMouseLeave={handleMouseLeave}
					>
						{trigger.props.children}
					</div>
				)}
			</div>

			{visible &&
				<div ref={setPopperElement} style={{ ...styles.popper, zIndex: 1 }} {...attributes.popper}>
					{content && (
						<div
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}
						>
							{content.props.children}
						</div>
					)}
				</div>
			}
		</div>
	)
}

PopoverWithState.Trigger = Trigger
PopoverWithState.Content = Content

export default PopoverWithState
